<div class="tab-details">
  <div
    class="loyalty-tab tab-pane d-flex flex-column spacing-24"
    id="loyalty-tab-pane"
    role="tabpanel"
    aria-labelledby="loyalty-tab">
    <div class="order-status">
      <div class="ce-row">
        <div class="ce-col-lg-3 ce-col-md-3 ce-col-sm-6 ce-col-12">
          <!-- TODO: Add analytics trend widget for tier -->
        </div>
        <div class="ce-col-lg-3 ce-col-md-3 ce-col-sm-6 ce-col-12">
          <!-- TODO: Add analytics trend widget for total points -->
        </div>

        <div class="ce-col-lg-3 ce-col-md-3 ce-col-sm-6 ce-col-12">
          <!-- TODO: Add analytics trend widget for points earned -->
        </div>
        <div class="ce-col-lg-3 ce-col-md-3 ce-col-sm-6 ce-col-12">
          <!-- TODO: Add analytics trend widget for points redeemed -->
        </div>
      </div>
    </div>
    <div class="ce-row">
      <div class="ce-col-12">
        <div class="table-component d-flex flex-column spacing-24">
          <app-table-view
            [table_schema]="schema"
            (onClick)="onActionClick($event)"
            [loader]="customerLoyaltyLoader$ | async"
            [errorMessage]="errorMessage$ | async"
            (onSort)="onSortColumn($event)"></app-table-view>
        </div>
      </div>
    </div>
  </div>
  <footer class="layout-footer sticky-footer">
    <div class="ce-row">
      <div class="ce-col-12 pt-0 pb-0">
        <app-list-footer [pagination]="pagination" (onPageChange)="onPageChange($event)">
        </app-list-footer>
      </div>
    </div>
  </footer>
</div>
